import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DRAWER_KEY, FIREBASE_EVENTS, INVOICES_DRAWER_STAGES } from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import { fetchBankSlips } from 'slices/financial'
import { setDrawer, setHeaderVisibility, setStage } from 'slices/drawer'
import { InvoicesError, InvoicesList } from './components'
import { ContextLoader } from '../../../context-loader'
import { DrawerHeader } from '../../../drawer-header'

export function Invoices() {
  const { stage } = useSelector(({ drawer }) => drawer)
  const { id } = useSelector(state => state.contract.selected)
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()
  const { bankSlips } = useSelector(state => state.financial)

  useEffect(() => {
    sendEvent(FIREBASE_EVENTS.CLICK_ON_ACCESS_DRAWER_GIGA_HELP)
  }, [sendEvent])

  useEffect(() => {
    function handleInitialConfig() {
      dispatch(fetchBankSlips(id))
      dispatch(setHeaderVisibility(false))

      if (bankSlips.error) dispatch(setStage(INVOICES_DRAWER_STAGES.INVOICES_ERROR))
    }

    handleInitialConfig()
  }, [dispatch, id, bankSlips.error])

  function handleCloseClick() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  function renderContentOrLoading() {
    const { isLoading } = bankSlips

    if (isLoading) return <ContextLoader fixed={false} />

    return (
      <>
        <DrawerHeader hideBackButton title='Giga+ Ajuda' color onClose={handleCloseClick} />
        {stages({})[stage]}
      </>
    )
  }

  return renderContentOrLoading()
}

function stages({ ...props }) {
  return {
    [INVOICES_DRAWER_STAGES.INITIAL]: <InvoicesList {...props} />,
    [INVOICES_DRAWER_STAGES.INVOICES_ERROR]: <InvoicesError {...props} />,
  }
}
